<ion-card class="tarjeta-visitas">
  <ion-card-header>
    <div class="header-visitas">
      <!-- Primera fila: Título, subtítulo y botones -->
      <div class="header-fila-principal">
        <div class="titulo-seccion">
          <div class="titulo-con-informacion">
            <ion-card-title>{{ titulo }}</ion-card-title>
            <ion-button *ngIf="informacion" [id]="idUnico" fill="clear" size="small" class="boton-informacion"
              aria-label="Información">
              <ion-icon name="information-circle-outline" slot="icon-only"></ion-icon>
            </ion-button>
          </div>
          <ion-card-subtitle>{{ subtituloDinamico }}</ion-card-subtitle>
        </div>
        <div class="botones-header">
          <ion-button *ngIf="mostrarBotonSincronizarRutaDia" color="primary" fill="outline"
            (click)="confirmarSincronizarRutaDelDia()"
            title="Sincronizar Ruta del Día" aria-label="Sincronizar Ruta del Día">
            <ion-icon slot="start" name="sync-outline" aria-hidden="true"></ion-icon>
            Sincronizar
          </ion-button>
          <!-- Botón exportar CSV -->
          <ion-button class="boton-exportar-csv" fill="clear" size="small" (click)="exportarCSV()"
            title="Exportar a CSV" aria-label="Exportar a CSV">
            <ion-icon slot="icon-only" name="download-outline"></ion-icon>
          </ion-button>

          <!-- Botón Agendar (responsivo): según permiso agendar y input -->
          <ion-button *ngIf="puedeCrear() && mostrarBotonNuevaVisita" id="btn-agendar-visita" class="btn-nueva-visita"
            (click)="onNuevaVisitaClick()">
            <span class="texto-btn-corto">Agendar</span>
            <span class="texto-btn-completo">Agendar</span>
            <ion-icon slot="start" name="add-outline"></ion-icon>
          </ion-button>
        </div>
      </div>

      <!-- Segunda fila: Filtros -->
      <div class="filtros-header">
        <!-- Buscador -->
        <div class="buscador-container">
          <ion-searchbar [(ngModel)]="terminoBusqueda" placeholder="Buscar..." (ionInput)="buscarVisitas()"
            (ionClear)="limpiarBusqueda()" debounce="700" class="buscador-visitas">
          </ion-searchbar>
        </div>

        <!-- Filtro de tipo -->
        <div class="filtro-tipo-container">
          <ion-select [(ngModel)]="tipoSeleccionado" (ionChange)="onFiltroTipoChange($event)"
            (click)="onSelectorClick('tipo')" interface="popover" placeholder="Todos los tipos"
            class="select-filtro-tipo" [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }">
            <ion-select-option [value]="null">Todos los tipos</ion-select-option>
            <ion-select-option *ngFor="let tipo of tiposVisita" [value]="tipo.id_tipo_visita"
              [attr.data-tipo]="getClaseTipo(tipo.descripcion, tipo.id_tipo_visita)">
              {{ tipo.descripcion }}
            </ion-select-option>
          </ion-select>
        </div>

        <!-- Filtro de fecha -->
        <div class="filtro-fecha-container">
          <ion-select [(ngModel)]="filtroFechaSeleccionado" (ionChange)="onFiltroFechaChange($event)"
            interface="popover" placeholder="Filtrar por fecha" class="select-filtro-fecha"
            [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }">
            <ion-select-option *ngFor="let opcion of opcionesFiltroFecha" [value]="opcion.valor">
              {{ opcion.etiqueta }}
            </ion-select-option>
          </ion-select>
        </div>

        <!-- Filtro de estado -->
        <div class="filtro-estado-container">
          <ion-select [(ngModel)]="estadoFiltroValor" (ionChange)="onFiltroEstadoChange($event)"
            [compareWith]="compararValorEstadoFiltro"
            (click)="onSelectorClick('estado')" interface="popover" placeholder="Todos los estados"
            class="select-filtro-estado" [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }">
            <ion-select-option [value]="null">Todos los estados</ion-select-option>
            <ion-select-option *ngFor="let estado of opcionesEstadoFiltro" [value]="estado.valor"
              [attr.data-estado]="estado.claseEstado">
              {{ estado.etiqueta }}
            </ion-select-option>
          </ion-select>
        </div>
      </div>
    </div>

    <!-- Rango de fechas personalizado -->
    <div class="rango-personalizado" *ngIf="mostrarRangoPersonalizado">
      <ion-item>
        <ion-label position="stacked">Desde</ion-label>
        <ion-button size="small" fill="clear" (click)="abrirPopoverFecha('desde', $event)">
          <ion-icon name="calendar-outline" slot="start"></ion-icon>
          {{ fechaDesdeISO ? (fechaDesdeISO | date:'dd/MM/yyyy') : 'Seleccionar' }}
        </ion-button>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Hasta</ion-label>
        <ion-button size="small" fill="clear" (click)="abrirPopoverFecha('hasta', $event)">
          <ion-icon name="calendar-outline" slot="start"></ion-icon>
          {{ fechaHastaISO ? (fechaHastaISO | date:'dd/MM/yyyy') : 'Seleccionar' }}
        </ion-button>
      </ion-item>
      <ion-button size="small" (click)="aplicarRangoPersonalizado()">
        Aplicar
      </ion-button>
    </div>
  </ion-card-header>

  <ion-card-content>
    <!-- Spinner de carga -->
    <div class="loading-container" *ngIf="cargandoVisitas">
      <ion-spinner name="crescent"></ion-spinner>
      <p>Cargando visitas...</p>
    </div>

    <!-- Vista Desktop: Tabla de visitas -->
    <div class="tabla-container vista-desktop" *ngIf="!cargandoVisitas">
      <table class="tabla-visitas">
        <thead>
          <tr>
            <th *ngFor="let col of columnasOrdenables" class="th-sortable" (click)="onSortColumn(col.id)"
              [attr.aria-sort]="isColumnaOrdenActiva(col.sortKey) ? (sortOrder === 'asc' ? 'ascending' : 'descending') : null"
              [attr.title]="'Ordenar por ' + col.label">
              <span class="th-sortable-content">
                <span class="th-sortable-label">{{ col.label }}</span>
                <span class="th-sort-icon" [class.activo]="isColumnaOrdenActiva(col.sortKey)" aria-hidden="true">
                  <ion-icon
                    [name]="isColumnaOrdenActiva(col.sortKey) ? (sortOrder === 'asc' ? 'arrow-up' : 'arrow-down') : 'swap-vertical-outline'"></ion-icon>
                </span>
              </span>
            </th>
            <th *ngIf="mostrarColumnaAcciones && puedeAlgunaAccionVisitas()" class="col-header-acciones">
              <span class="texto-header-acciones">Acciones</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let visita of visitas; let i = index" (click)="onVisitaClick(visita)" class="fila-visita">
            <td class="col-usuario">
              <span class="nombre-usuario">{{ getNombreUsuarioIndap(visita.productor) }}</span>
              <span class="rut-usuario" *ngIf="getRutUsuarioIndap(visita.productor)">({{
                getRutUsuarioIndap(visita.productor) }})</span>
            </td>
            <td class="col-unidad">{{ visita.productor.jerarquia.descripcion || '---' }}</td>
            <td class="col-tipo">
              <span class="tipo-con-circulo" [ngClass]="getClaseTipo(visita.tipo)">
                <span class="circulo-tipo"></span>
                <span class="texto-tipo">{{ visita.tipo || '-' }}</span>
              </span>
            </td>
            <td class="col-descripcion">
              <span class="descripcion-celda" [attr.title]="getDescripcionVisita(visita) !== '-' ? getDescripcionVisita(visita) : null">{{ getDescripcionVisita(visita) }}</span>
            </td>
            <td class="col-fecha">
              <span *ngIf="visita.estado?.toLowerCase() == 'planificada'" class="fecha-linea">{{ formatearSoloFechasVisita(visita) }}</span>
              <span *ngIf="visita.estado?.toLowerCase() != 'planificada'" class="fecha-linea">{{ formatearSoloFechaVisita(getFechaHoraParaListado(visita)) }}</span>
              <span *ngIf="visita.estado?.toLowerCase() != 'planificada'" class="hora-linea">{{ formatearSoloHoraVisita(getFechaHoraParaListado(visita)) }}</span>
            </td>
            <td class="col-lugar">{{ visita.lugar || '-' }}</td>
            <td class="col-estado">
              <span class="estado-y-contingencia">
                <span class="badge-estado" [ngClass]="getClaseEstado(visita.estado)">
                  {{ getEtiquetaEstadoListado(visita) }}
                </span>
                <button *ngIf="visita.es_contingencia" type="button"
                  class="trigger-contingencia"
                  (click)="abrirPopoverContingencia($event, visita)" aria-label="Contingencia">
                  <ion-icon name="alert-circle"></ion-icon>
                </button>
              </span>
            </td>
            <td class="col-acciones" *ngIf="mostrarColumnaAcciones && puedeAlgunaAccionVisitas()">
              <ion-button fill="clear" size="small" class="btn-acciones"
                (click)="abrirMenuAcciones($event, visita)">
                <ion-icon slot="icon-only" name="ellipsis-horizontal-outline"></ion-icon>
              </ion-button>
            </td>
          </tr>
          <tr *ngIf="visitas.length === 0">
            <td [attr.colspan]="(mostrarColumnaAcciones && puedeAlgunaAccionVisitas()) ? 8 : 7" class="sin-datos">
              <ion-icon name="calendar-outline"></ion-icon>
              <p>No se encontraron visitas para los filtros seleccionados.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Vista Móvil: Lista de tarjetas -->
    <div class="lista-visitas-mobile vista-mobile" *ngIf="!cargandoVisitas">
      <!-- Mensaje sin datos -->
      <div class="sin-datos-mobile" *ngIf="visitas.length === 0">
        <ion-icon name="calendar-outline"></ion-icon>
        <p>No se encontraron visitas para los filtros seleccionados.</p>
      </div>

      <!-- Tarjetas de visitas -->
      <div class="visita-card" *ngFor="let visita of visitas; let i = index" (click)="onVisitaClick(visita)">
        <div class="visita-card-header">
          <div class="visita-usuario">
            <ion-icon name="person-outline"></ion-icon>
            <span class="nombre-usuario">{{ getNombreUsuarioIndap(visita.productor) }}</span>
            <span class="rut-usuario" *ngIf="getRutUsuarioIndap(visita.productor)">({{
              getRutUsuarioIndap(visita.productor) }})</span>
          </div>
          <span class="estado-y-contingencia">
            <span class="badge-estado" [ngClass]="getClaseEstado(visita.estado)">
              {{ getEtiquetaEstadoListado(visita) }}
            </span>
            <button *ngIf="visita.es_contingencia" type="button"
              class="trigger-contingencia trigger-contingencia-mobile"
              (click)="abrirPopoverContingencia($event, visita)" aria-label="Contingencia">
              <ion-icon name="warning"></ion-icon>
            </button>
          </span>
        </div>
        <div class="visita-card-body">
          <div class="visita-info-row">
            <ion-icon name="calendar-outline"></ion-icon>
            <span>{{ formatearFechaVisita(getFechaHoraParaListado(visita)) }}</span>
          </div>
          <div class="visita-info-row">
            <ion-icon name="business-outline"></ion-icon>
            <span>{{ visita.productor.jerarquia.descripcion || '---' }}</span>
          </div>
          <div class="visita-info-row" *ngIf="getDescripcionVisita(visita) !== '-'">
            <ion-icon name="document-text-outline"></ion-icon>
            <span class="visita-descripcion-mobile" [attr.title]="getDescripcionVisita(visita) !== '-' ? getDescripcionVisita(visita) : null">{{ getDescripcionVisita(visita) }}</span>
          </div>
          <div class="visita-info-row" *ngIf="visita.lugar">
            <ion-icon name="location-outline"></ion-icon>
            <span>{{ visita.lugar }}</span>
          </div>
          <div class="visita-info-row" *ngIf="visita.tipo">
            <ion-icon name="document-text-outline"></ion-icon>
            <span class="tipo-con-circulo" [ngClass]="getClaseTipo(visita.tipo)">
              <span class="circulo-tipo"></span>
              <span class="texto-tipo">{{ visita.tipo }}</span>
            </span>
          </div>
        </div>
        <div class="visita-card-footer" *ngIf="mostrarColumnaAcciones && puedeAlgunaAccionVisitas()">
          <ion-button fill="clear" size="small" class="btn-acciones-mobile"
            (click)="abrirMenuAcciones($event, visita)">
            <ion-icon slot="start" name="ellipsis-horizontal-outline"></ion-icon>
            Opciones
          </ion-button>
        </div>
      </div>
    </div>

    <!-- Paginación -->
    <div class="paginacion-container" *ngIf="!cargandoVisitas && visitas.length > 0">
      <div class="info-paginacion">
        <span>Página {{ paginaActual }} de {{ totalPaginas }} ({{ totalRegistros }} registro{{ totalRegistros !== 1 ?
          's' : '' }})</span>
        <div class="selector-tamanio">
          <ion-select [(ngModel)]="tamanioPagina" (ionChange)="onTamanioPaginaChange($event)" interface="popover"
            class="select-tamanio-pagina" [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }">
            <ion-select-option *ngFor="let tamanio of opcionesTamanioPagina" [value]="tamanio">
              {{ tamanio }} por página
            </ion-select-option>
          </ion-select>
        </div>
      </div>
      <div class="controles-paginacion">
        <ion-button fill="clear" size="small" [disabled]="paginaActual === 1" (click)="irAPagina(1)">
          <ion-icon slot="icon-only" name="play-skip-back-outline"></ion-icon>
        </ion-button>
        <ion-button fill="clear" size="small" [disabled]="paginaActual === 1" (click)="paginaAnterior()">
          <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
        </ion-button>

        <div class="numeros-pagina">
          <ion-button *ngFor="let pagina of getPaginasArray()" [fill]="pagina === paginaActual ? 'solid' : 'clear'"
            [color]="pagina === paginaActual ? 'primary' : 'medium'" size="small" (click)="irAPagina(pagina)">
            {{ pagina }}
          </ion-button>
        </div>

        <ion-button fill="clear" size="small" [disabled]="paginaActual >= totalPaginas" (click)="paginaSiguiente()">
          <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
        </ion-button>
        <ion-button fill="clear" size="small" [disabled]="paginaActual >= totalPaginas"
          (click)="irAPagina(totalPaginas)">
          <ion-icon slot="icon-only" name="play-skip-forward-outline"></ion-icon>
        </ion-button>
      </div>
    </div>
  </ion-card-content>
</ion-card>

<!-- Popover único de acciones (desktop + mobile): evita el bug de Ionic con triggers en ngFor -->
<ion-popover
  [isOpen]="menuAccionesAbierto"
  [event]="menuAccionesEvent"
  (ionPopoverDidDismiss)="cerrarMenuAcciones()"
  dismissOnSelect="true"
  side="bottom"
  alignment="start">
  <ng-template>
    <ion-list lines="none">
      <ion-item button (click)="onReagendarClick(visitaMenuActiva!)" *ngIf="visitaMenuActiva && puedeReagendar(visitaMenuActiva)">
        <ion-icon slot="start" name="calendar-outline"></ion-icon>
        <ion-label>Reagendar</ion-label>
      </ion-item>
      <ion-item button (click)="onReagendarClick(visitaMenuActiva!)" *ngIf="visitaMenuActiva && mostrarOpcionAgendar(visitaMenuActiva)">
        <ion-icon slot="start" name="calendar-outline"></ion-icon>
        <ion-label>Agendar</ion-label>
      </ion-item>
      <ion-item button [disabled]="cancelarEstaDeshabilitado(visitaMenuActiva!)" (click)="onCancelarClick(visitaMenuActiva!)" *ngIf="visitaMenuActiva && puedeCancelar(visitaMenuActiva)">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        <ion-label>Cancelar</ion-label>
      </ion-item>
      <ion-item button (click)="onRegistrarClick(visitaMenuActiva!)" *ngIf="visitaMenuActiva && puedeRegistrar(visitaMenuActiva)">
        <ion-icon slot="start" name="checkmark-circle-outline"></ion-icon>
        <ion-label>Finalizar</ion-label>
      </ion-item>
      <ion-item
        *ngIf="visitaMenuActiva && esExtensionista && esVisitaFinalizada(visitaMenuActiva.estado)"
        button
        (click)="onSubirResumenFirmadoClick(visitaMenuActiva!)">
        <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>
        <ion-label>Subir resumen Firmado</ion-label>
      </ion-item>
      <ion-item button (click)="onVerDetallesClick(visitaMenuActiva!)" *ngIf="puedeVerDetalles()">
        <ion-icon slot="start" name="eye-outline"></ion-icon>
        <ion-label>Ver Detalles</ion-label>
      </ion-item>
    </ion-list>
  </ng-template>
</ion-popover>

<!-- Popover único de contingencia -->
<ion-popover
  [isOpen]="popoverContingenciaAbierto"
  [event]="popoverContingenciaEvent"
  (ionPopoverDidDismiss)="cerrarPopoverContingencia()"
  side="top"
  alignment="center">
  <ng-template>
    <div class="popover-emergencia">
      <h4>Visita de Emergencia</h4>
      <p>{{ getDescripcionEmergenciaPopover() }}</p>
    </div>
  </ng-template>
</ion-popover>

<!-- Popover de información: side="top" y reference="trigger" para alineación correcta en iPad/Chrome -->
<ion-popover *ngIf="informacion" [trigger]="idUnico" [triggerAction]="'click'" reference="trigger" [side]="'top'"
  [alignment]="'center'">
  <ng-template>
    <div class="popover-informacion">
      <p>{{ informacion }}</p>
    </div>
  </ng-template>
</ion-popover>

<!-- Popover para selector de fecha "Desde" -->
<ion-popover [isOpen]="popoverFechaDesdeAbierto" [event]="popoverFechaEvent" (didDismiss)="onPopoverFechaDismiss('desde')">
  <ng-template>
    <ion-datetime *ngIf="popoverFechaDesdeAbierto" id="datetime-desde" [(ngModel)]="fechaDesdeISO"
      (ionChange)="onFechaDesdeChange($event)" locale="es-CL" presentation="date"
      [max]="fechaHastaISO || fechaMaximaISO" [formatOptions]="opcionesFormatoFecha"></ion-datetime>
  </ng-template>
</ion-popover>

<!-- Popover para selector de fecha "Hasta" -->
<ion-popover [isOpen]="popoverFechaHastaAbierto" [event]="popoverFechaEvent" (didDismiss)="onPopoverFechaDismiss('hasta')">
  <ng-template>
    <ion-datetime *ngIf="popoverFechaHastaAbierto" id="datetime-hasta" [(ngModel)]="fechaHastaISO"
      (ionChange)="onFechaHastaChange($event)" locale="es-CL" presentation="date"
      [min]="fechaDesdeISO || undefined" [max]="fechaMaximaISO"
      [formatOptions]="opcionesFormatoFecha"></ion-datetime>
  </ng-template>
</ion-popover>